import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import service_docs from 'services/docs';
import helpers from 'utils/helpers';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { Box, Flex, Heading } from 'rebass';
import { Select, Label } from '@rebass/forms';
import { isMobile } from 'react-device-detect';
import { MarketingHeader } from 'components/Marketing';
const contentfulAssetOptions = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: ({
            data: {
                target: { fields }
            }
        }) =>
            `<a href="${fields.file.url}" target="_blank"><img src="${fields.file.url}" style="max-width: 100%;height: auto;" alt="${fields.description}" class='border'/></a>`,
            // `<img src="${fields.file.url}" height="${fields.file.details.image.height}" width="${fields.file.details.image.width}" alt="${fields.description}" class='border'/>`,
        [BLOCKS.HEADING_2]: (node, next) =>
            `<h2 id="${helpers.stringToHtmlId(node.content[0].value)}">${next(node.content)}</h2>`
    }
};

export default function DocumentationPage(props) {
    const [slug, setSlug] = useState([]);
    const [anchors, setAnchors] = useState([]);
    const [documentationNav, setDocumentationNav] = useState([]);
    const [documentationData, setDocumentationData] = useState({});
    const [documentationDataNotFound, setDocumentationDataNotFound] = useState(false);

    // console.log(props.match.params)

    useEffect(() => {
        getDocumentationNavXHR();
        let slug_params;
        if (props.match.params.section && props.match.params.page) {
            slug_params = `${props.match.params.section}/${props.match.params.page}`;
        } else {
            slug_params = 'overview/introduction';
        }
        setSlug(slug_params);
        getDocumentationDataXHR(slug_params);
    }, [props.match.params.section, props.match.params.page]);

    function getDocumentationNavXHR() {
        service_docs
            .getDocumentationNav()
            .then(navItems => {
                console.log('navItems', navItems);
                setDocumentationNav(navItems.fields.body);
            })
            .catch(e => console.log(e));
    }

    function getDocumentationDataXHR(new_slug) {
        console.log('getDocumentationDataXHR', new_slug);
        setDocumentationDataNotFound(false);
        service_docs.getDocumentationDataBySlug(new_slug).then(dd => {
            if (dd && dd.items && dd.items.length) {
                const page_data = dd.items[0];
                setDocumentationData(page_data);
                generatePageAnchors(page_data);
            } else {
                setDocumentationDataNotFound(true);
            }
        });
    }

    function generatePageAnchors(data) {
        const anchors_array = [];
        if (data && data.fields && data.fields.body && data.fields.body.content) {
            data.fields.body.content.forEach(c => {
                if (c.nodeType == 'heading-2') {
                    if (c.content && c.content[0] && c.content[0].value) {
                        anchors_array.push({
                            title: c.content[0].value,
                            id: `#${helpers.stringToHtmlId(c.content[0].value)}`
                        });
                    }
                }
            });
        }
        setAnchors(anchors_array);
    }

    function mobileNavigate(e) {
        setSlug(e.target.value);
        getDocumentationDataXHR(e.target.value);
    }

    return (
        <Flex flexDirection="column" style={{ margin: '0px auto', width: '100%' }}>
            <Helmet>
                <title>{(documentationData && documentationData.fields) ? documentationData.fields.title : ''} - Documentation</title>
            </Helmet>
            <MarketingHeader fullwidth notSticky auth={props.auth} />
            <Flex className={`docs-wrapper ${isMobile ? 'mobile' : ''}`}>
                <Box className={`docs-nav ${isMobile ? 'mobile' : ''}`}>
                    {documentationNav &&
                        (isMobile ? (
                            <>
                                <Label mb={2}>Navigate Docs</Label>
                                <Select value={slug} onChange={e => mobileNavigate(e)}>
                                    {documentationNav.map(item => (
                                        <>
                                            {item.type == 'heading' && <option disabled>{item.title}</option>}
                                            {item.type == 'link' && (
                                                <>
                                                    <option value={item.slug}>{item.title}</option>
                                                </>
                                            )}
                                        </>
                                    ))}
                                </Select>
                            </>
                        ) : (
                            <>
                                {documentationNav.map(item => (
                                    <>
                                        {item.type == 'heading' && <div className="section-header">{item.title}</div>}
                                        {item.type == 'link' && (
                                            <>
                                                <NavLink
                                                    to={`/docs/${item.slug}`}
                                                    activeClassName="is-active"
                                                    className={
                                                        slug == 'overview/introduction' && slug == item.slug
                                                            ? 'is-active'
                                                            : ''
                                                    }
                                                    onClick={() => setAnchors([])}
                                                >
                                                    {item.title}
                                                </NavLink>
                                                {slug == item.slug &&
                                                    anchors.map(a => (
                                                        <a href={a.id} style={{ marginLeft: '16px' }}>
                                                            {a.title}
                                                        </a>
                                                    ))}
                                            </>
                                        )}
                                    </>
                                ))}
                                <br/><br/>
                            </>
                        ))}
                </Box>
                <Box className={`docs-body  ${isMobile ? 'mobile' : ''}`}>
                    <Box>
                        {documentationDataNotFound == true && (
                            <>
                                <Heading color="black" mb={4}>
                                    Documentation page not found
                                </Heading>

                                <hr />
                                <Box mt={4} fontSize={1}>
                                    Go to <Link to="/docs">Documentation Home</Link> or please email{' '}
                                    <a href="mailto:support@panelfox.io">support@panelfox.io</a> for help.
                                </Box>
                            </>
                        )}
                        {documentationData && documentationData.fields && (
                            <>
                                <Heading color="black" mb={4}>
                                    {documentationData.fields.title}
                                </Heading>

                                <hr />
                                <Box mt={4} fontSize={1}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            // SKIP myxss.process() BECAUSE THIS IS COMING FROM CONTENTFUL
                                            // @TODO make a unique rule for contentful and apply myxss
                                            __html: documentToHtmlString(
                                                documentationData.fields.body,
                                                contentfulAssetOptions
                                            )
                                        }}
                                    ></div>
                                </Box>
                            </>
                        )}
                    </Box>
                </Box>
            </Flex>
        </Flex>
    );
}
